import {
  age1,
  age2,
  age3,
  age4,
  femaleImage,
  lightningImage,
  lionImage,
  maleImage,
  muscleImage,
  relaxImage,
  scaleImage,
  smileImage,
  step4female1Image,
  step4female2Image,
  step4female3Image,
  step4female4Image,
  step4male1Image,
  step4male2Image,
  step4male3Image,
  step4male4Image,
  step5female1Image,
  step5female2Image,
  step5female3Image,
  step5female4Image,
  step5male1Image,
  step5male2Image,
  step5male3Image,
  step5male4Image,
  step6neverImage,
  step6OneYearImage,
  step6threeYearsImage,
  step6twoYearsImage,
  step7afternoonImage,
  step7eveningImage,
  step7morningImage,
  step11bothImage,
  step11buyImage,
  step11myselfImage,
  step12crossImage,
  step12hundredImage,
  step12tickImage,
  step13cookingImage,
  step13fishImage,
  step13mangoImage,
  step13otherImage,
  step13sandwichImage,
  step13veganImage,
  step13vegetarianImage,
  step14sleepingFaceImage,
  step14snowmanImage,
  step14superHeroImage,
  step14zzzzImage,
  step15ballImage,
  step15manInLotusImage,
  step15manLiftingImage,
  step15trophyImage,
  step15yawningFaceImage,
  step16oldManImage,
  step16policeImage,
  step16technilogistImage,
  step16womanImage,
  step18runningManImage,
  step18walkingManImage,
  step21boxImage,
  step21friesImage,
  step21glassImage,
  step21lollipopImage,
  step21popcornImage,
  step23huggingFaceImage,
  step23partingFaceImage,
  step23smilingFaceImage,
  step28airplaneImage,
  step28badmintonImage,
  step28carImage,
  step28familyImage,
  step28umbrellaImage,
  step28wineImage,
} from '@src/assets/images';
import { is12HourFormat } from '@src/helpers/date.helpers';
import { isMale } from '@src/helpers/gender.helpers';

import { IStateContextData } from '../interfaces/state.interfaces';

const is12h = is12HourFormat();

export const INTERMITTENT_FASTING = {
  VERY: 1,
  SOMEWHAT: 2,
  HEARD: 3,
  NOT: 4,
} as const;

export type IIntermittentFasting =
  (typeof INTERMITTENT_FASTING)[keyof typeof INTERMITTENT_FASTING];

export const ACHIEVE = {
  LOSE: 1,
  GET_TONED: 2,
  MAINTAIN_WEIGHT: 3,
  IMPROVE_SKIN: 4,
  IMPROVE_ENERGY_LEVELS: 5,
  IMPROVE_MOOOD: 6,
} as const;

export type IAchieve = (typeof ACHIEVE)[keyof typeof ACHIEVE];

export const GENDER = {
  MALE: 'male',
  FEMALE: 'female',
  OTHER: 'other',
} as const;

export type IGender = (typeof GENDER)[keyof typeof GENDER];

export const CURRENT_BODY_TYPE = {
  SLENDER: 1,
  MEDIUM_BUILD: 2,
  STOCKY: 3,
  OVERWEIGHT: 4,
} as const;

export type ICurrentBodyType =
  (typeof CURRENT_BODY_TYPE)[keyof typeof CURRENT_BODY_TYPE];

export const IDEAL_BODY_TYPE = {
  THIN: 1,
  ATHLETIC: 2,
  SHREDDED: 3,
  SWOLE: 4,
} as const;

export type IIdealBodyType =
  (typeof IDEAL_BODY_TYPE)[keyof typeof IDEAL_BODY_TYPE];

export const LAST_HAPPY = {
  LESS_YEAR: 1,
  ONE_TWO_YEARS: 2,
  MORE_THREE_YEARS: 3,
  NEVER: 4,
} as const;

export type ILastHappy = (typeof LAST_HAPPY)[keyof typeof LAST_HAPPY];

export const FEEL_HUNGRY = {
  MORNING: 1,
  AFTERNOON: 2,
  EVENING: 3,
} as const;

export type IFeelHungry = (typeof FEEL_HUNGRY)[keyof typeof FEEL_HUNGRY];

export const TIME_BREAKFAST = {
  SIX_EIGHT: 1,
  EIGHT_TEN: 2,
  TEN_TWELVE: 3,
  SKIP: 4,
} as const;

export type ITimeBreakfast =
  (typeof TIME_BREAKFAST)[keyof typeof TIME_BREAKFAST];

export const TIME_LUNCH = {
  TEN_TWELVE: 1,
  TWELVE_FOURTEEN: 2,
  FOURTEEN_SIXTEEN: 3,
  SKIP: 4,
} as const;

export type ITimeLunch = (typeof TIME_LUNCH)[keyof typeof TIME_LUNCH];

export const TIME_DINNER = {
  SIXTEEN_EIGHTEEN: 1,
  EIGHTEEN_TWENTY: 2,
  TWENTY_TWENTY_TWO: 3,
  SKIP: 4,
} as const;

export type ITimeDinner = (typeof TIME_DINNER)[keyof typeof TIME_DINNER];

export const PREPARE_MEALS = {
  MYSELF: 1,
  BUY: 2,
  BOTH: 3,
} as const;

export type IPrepareMeals = (typeof PREPARE_MEALS)[keyof typeof PREPARE_MEALS];

export const FASTING_WEEKENDS = {
  IMPOSSIBLE: 1,
  CAN: 2,
  NO_PROBLEM: 3,
} as const;

export type IFastingWeekends =
  (typeof FASTING_WEEKENDS)[keyof typeof FASTING_WEEKENDS];

export const DIETARY_PATTERN = {
  NONE: 0,
  VEGETARIAN: 1,
  VEGAN: 2,
  PESCATARIAN: 3,
  LACTOSE: 4,
  GLUTEN: 5,
  KETO: 6,
  OTHER: 7,
} as const;

export type IDietaryPattern =
  (typeof DIETARY_PATTERN)[keyof typeof DIETARY_PATTERN];

export const SLEEP = {
  FEWER_FIVE: 1,
  FIVE_SIX: 2,
  SEVEN_EIGHT: 3,
  OVER_EIGHT: 4,
} as const;

export type ISleep = (typeof SLEEP)[keyof typeof SLEEP];

export const PHYSICALLY_ACTIVE = {
  SEDENTARY: 0,
  LIGHTLY: 1,
  MODERATELY: 2,
  VERY: 3,
  EXTRA: 4,
} as const;

export type IPhysicallyActive =
  (typeof PHYSICALLY_ACTIVE)[keyof typeof PHYSICALLY_ACTIVE];

export const WORKING_HOURS = {
  FIVE_SIX: 1,
  NIGHT: 2,
  MIXED: 3,
  RETIRED: 4,
} as const;

export type IWorkingHours = (typeof WORKING_HOURS)[keyof typeof WORKING_HOURS];

export const STAIRS_BREATH = {
  CANNOT_TALK: 1,
  CAN_TALK: 2,
  OK: 3,
  EASILY: 4,
} as const;

export type IStairsBreath = (typeof STAIRS_BREATH)[keyof typeof STAIRS_BREATH];

export const WALKING_TYPICAL_DAY = {
  LESS_TWENTY: 1,
  TWENTY_SIXTY: 2,
  MORE_SIXTY: 3,
} as const;

export type IWalkingTypicalDay =
  (typeof WALKING_TYPICAL_DAY)[keyof typeof WALKING_TYPICAL_DAY];

export const DAILY_MEALS = {
  ONE_TWO: 1,
  TWO_THREE: 2,
  THREE_FOUR: 3,
  MORE_FOUR: 4,
} as const;

export type IDailyMeals = (typeof DAILY_MEALS)[keyof typeof DAILY_MEALS];

export const BAD_HABITS = {
  NONE: 0,
  SNACK_TOO_OFTEN: 1,
  CRAVE_SALTY_FOODS: 2,
  UNCONTROLLABLE_SWEET_TOOTH: 3,
  DRINKING_SOFT_DRINKS: 4,
  ALCOHOL_TOO_OFTEN: 5,
} as const;

export type IBadHabits = (typeof BAD_HABITS)[keyof typeof BAD_HABITS];

export const LIFESTYLE = {
  SITTING: 1,
  MOVE: 2,
  FEET: 3,
} as const;

export type ILifestyle = (typeof LIFESTYLE)[keyof typeof LIFESTYLE];

export const ACHIEVE_YOUR_TARGET_WEIGHT = {
  CANT_WAIT: 1,
  OPTIMISTIC: 2,
  JUST_TRY: 3,
} as const;

export type IAchieveYourTargetWeight =
  (typeof ACHIEVE_YOUR_TARGET_WEIGHT)[keyof typeof ACHIEVE_YOUR_TARGET_WEIGHT];

export const LOSE_WEIGHT_FOR = {
  NONE: 0,
  VACATION: 1,
  WEDDING: 2,
  EVENT: 3,
  BEACH: 4,
  REUNION: 5,
  FAMILY: 6,
  OTHER: 7,
} as const;

export type ILoseWeightFor =
  (typeof LOSE_WEIGHT_FOR)[keyof typeof LOSE_WEIGHT_FOR];

export const QUESTIONS_CONSTANTS = {
  age: [
    {
      label: 'questions.age.list.1',
      image: age1,
    },
    {
      label: 'questions.age.list.2',
      image: age2,
    },
    {
      label: 'questions.age.list.3',
      image: age3,
    },
    {
      label: 'questions.age.list.4',
      image: age4,
    },
  ],
  intermittentFasting: [
    { label: 'questions.step1.list.1', value: INTERMITTENT_FASTING.VERY },
    { label: 'questions.step1.list.2', value: INTERMITTENT_FASTING.SOMEWHAT },
    { label: 'questions.step1.list.3', value: INTERMITTENT_FASTING.HEARD },
    { label: 'questions.step1.list.4', value: INTERMITTENT_FASTING.NOT },
  ],
  achieve: [
    {
      label: 'questions.step2.list.1',
      value: ACHIEVE.LOSE,
      image: scaleImage,
    },
    {
      label: 'questions.step2.list.9',
      value: ACHIEVE.GET_TONED,
      image: muscleImage,
    },
    {
      label: 'questions.step2.list.10',
      value: ACHIEVE.MAINTAIN_WEIGHT,
      image: relaxImage,
    },
    {
      label: 'questions.step2.list.11',
      value: ACHIEVE.IMPROVE_SKIN,
      image: lionImage,
    },
    {
      label: 'questions.step2.list.12',
      value: ACHIEVE.IMPROVE_ENERGY_LEVELS,
      image: lightningImage,
    },
    {
      label: 'questions.step2.list.13',
      value: ACHIEVE.IMPROVE_MOOOD,
      image: smileImage,
    },
  ],
  gender: [
    {
      label: 'questions.step3.list.1',
      value: GENDER.MALE,
      image: maleImage,
    },
    {
      label: 'questions.step3.list.2',
      value: GENDER.FEMALE,
      image: femaleImage,
    },
  ],
  current_body_type: (gender: IStateContextData['gender']) => [
    {
      label: `questions.step4.newList.1.${gender}`,
      value: CURRENT_BODY_TYPE.SLENDER,
      image: isMale(gender) ? step4male1Image : step4female1Image,
    },
    {
      label: `questions.step4.newList.2.${gender}`,
      value: CURRENT_BODY_TYPE.MEDIUM_BUILD,
      image: isMale(gender) ? step4male2Image : step4female2Image,
    },
    {
      label: `questions.step4.newList.3.${gender}`,
      value: CURRENT_BODY_TYPE.STOCKY,
      image: isMale(gender) ? step4male3Image : step4female3Image,
    },
    {
      label: `questions.step4.newList.4`,
      value: CURRENT_BODY_TYPE.OVERWEIGHT,
      image: isMale(gender) ? step4male4Image : step4female4Image,
    },
  ],
  ideal_body_type: (gender: IStateContextData['gender']) => [
    {
      label: `questions.step5.newList.1.${gender}`,
      value: IDEAL_BODY_TYPE.THIN,
      image: isMale(gender) ? step5male1Image : step5female1Image,
    },
    {
      label: `questions.step5.newList.2.${gender}`,
      value: IDEAL_BODY_TYPE.ATHLETIC,
      image: isMale(gender) ? step5male2Image : step5female2Image,
    },
    {
      label: `questions.step5.newList.3.${gender}`,
      value: IDEAL_BODY_TYPE.SHREDDED,
      image: isMale(gender) ? step5male3Image : step5female3Image,
    },
    {
      label: `questions.step5.newList.4.${gender}`,
      value: IDEAL_BODY_TYPE.SWOLE,
      image: isMale(gender) ? step5male4Image : step5female4Image,
    },
  ],
  last_happy: [
    {
      label: 'questions.step6.list.1',
      value: LAST_HAPPY.LESS_YEAR,
      image: step6OneYearImage,
    },
    {
      label: 'questions.step6.list.2',
      value: LAST_HAPPY.ONE_TWO_YEARS,
      image: step6twoYearsImage,
    },
    {
      label: 'questions.step6.list.3',
      value: LAST_HAPPY.MORE_THREE_YEARS,
      image: step6threeYearsImage,
    },
    {
      label: 'questions.step6.list.4',
      value: LAST_HAPPY.NEVER,
      image: step6neverImage,
    },
  ],
  feel_hungry: [
    {
      label: 'questions.step7.list.1',
      value: FEEL_HUNGRY.MORNING,
      image: step7morningImage,
    },
    {
      label: 'questions.step7.list.2',
      value: FEEL_HUNGRY.AFTERNOON,
      image: step7afternoonImage,
    },
    {
      label: 'questions.step7.list.3',
      value: FEEL_HUNGRY.EVENING,
      image: step7eveningImage,
    },
  ],
  time_breakfast: [
    {
      label: is12h ? 'questions.step8.list.1' : 'questions.step8.list.5',
      value: TIME_BREAKFAST.SIX_EIGHT,
    },
    {
      label: is12h ? 'questions.step8.list.2' : 'questions.step8.list.6',
      value: TIME_BREAKFAST.EIGHT_TEN,
    },
    {
      label: is12h ? 'questions.step8.list.3' : 'questions.step8.list.7',
      value: TIME_BREAKFAST.TEN_TWELVE,
    },
    {
      label: 'questions.step8.list.4',
      value: TIME_BREAKFAST.SKIP,
    },
  ],
  time_lunch: [
    {
      label: is12h ? 'questions.step9.list.1' : 'questions.step9.list.5',
      value: TIME_LUNCH.TEN_TWELVE,
    },
    {
      label: is12h ? 'questions.step9.list.2' : 'questions.step9.list.6',
      value: TIME_LUNCH.TWELVE_FOURTEEN,
    },
    {
      label: is12h ? 'questions.step9.list.3' : 'questions.step9.list.7',
      value: TIME_LUNCH.FOURTEEN_SIXTEEN,
    },
    {
      label: 'questions.step9.list.4',
      value: TIME_LUNCH.SKIP,
    },
  ],
  time_dinner: [
    {
      label: is12h ? 'questions.step10.list.1' : 'questions.step10.list.5',
      value: TIME_DINNER.SIXTEEN_EIGHTEEN,
    },
    {
      label: is12h ? 'questions.step10.list.2' : 'questions.step10.list.6',
      value: TIME_DINNER.EIGHTEEN_TWENTY,
    },
    {
      label: is12h ? 'questions.step10.list.3' : 'questions.step10.list.7',
      value: TIME_DINNER.TWENTY_TWENTY_TWO,
    },
    {
      label: 'questions.step10.list.4',
      value: TIME_DINNER.SKIP,
    },
  ],
  prepare_meals: [
    {
      label: 'questions.step11.list.1',
      value: PREPARE_MEALS.MYSELF,
      image: step11myselfImage,
    },
    {
      label: 'questions.step11.list.2',
      value: PREPARE_MEALS.BUY,
      image: step11buyImage,
    },
    {
      label: 'questions.step11.list.3',
      value: PREPARE_MEALS.BOTH,
      image: step11bothImage,
    },
  ],
  fasting_weekends: [
    {
      label: 'questions.step12.list.1',
      value: FASTING_WEEKENDS.IMPOSSIBLE,
      image: step12crossImage,
    },
    {
      label: 'questions.step12.list.2',
      value: FASTING_WEEKENDS.CAN,
      image: step12tickImage,
    },
    {
      label: 'questions.step12.list.3',
      value: FASTING_WEEKENDS.NO_PROBLEM,
      image: step12hundredImage,
    },
  ],
  dietary_pattern: [
    {
      label: 'questions.step13.list.1',
      value: DIETARY_PATTERN.NONE,
      image: step6neverImage,
    },
    {
      label: 'questions.step13.list.7',
      value: DIETARY_PATTERN.KETO,
      image: step13cookingImage,
    },
    {
      label: 'questions.step13.list.3',
      value: DIETARY_PATTERN.VEGAN,
      image: step13veganImage,
    },
    {
      label: 'questions.step13.list.2',
      value: DIETARY_PATTERN.VEGETARIAN,
      image: step13vegetarianImage,
    },
    {
      label: 'questions.step13.list.6',
      value: DIETARY_PATTERN.GLUTEN,
      image: step13mangoImage,
    },
    {
      label: 'questions.step13.list.4',
      value: DIETARY_PATTERN.PESCATARIAN,
      image: step13fishImage,
    },
    {
      label: 'questions.step13.list.5',
      value: DIETARY_PATTERN.LACTOSE,
      image: step13sandwichImage,
    },
    {
      label: 'questions.step13.list.8',
      value: DIETARY_PATTERN.OTHER,
      image: step13otherImage,
    },
  ],
  sleep: [
    {
      label: 'questions.step14.list.1',
      value: SLEEP.FEWER_FIVE,
      image: step14sleepingFaceImage,
    },
    {
      label: 'questions.step14.list.2',
      value: SLEEP.FIVE_SIX,
      image: step14zzzzImage,
    },
    {
      label: 'questions.step14.list.3',
      value: SLEEP.SEVEN_EIGHT,
      image: step14snowmanImage,
    },
    {
      label: 'questions.step14.list.4',
      value: SLEEP.OVER_EIGHT,
      image: step14superHeroImage,
    },
  ],
  physically_active: [
    {
      label: 'questions.step15.list.1.label',
      description: 'questions.step15.list.1.description',
      value: PHYSICALLY_ACTIVE.SEDENTARY,
      image: step15yawningFaceImage,
    },
    {
      label: 'questions.step15.list.2.label',
      description: 'questions.step15.list.2.description',
      value: PHYSICALLY_ACTIVE.LIGHTLY,
      image: step15manInLotusImage,
    },
    {
      label: 'questions.step15.list.3.label',
      description: 'questions.step15.list.3.description',
      value: PHYSICALLY_ACTIVE.MODERATELY,
      image: step15manLiftingImage,
    },
    {
      label: 'questions.step15.list.4.label',
      description: 'questions.step15.list.4.description',
      value: PHYSICALLY_ACTIVE.VERY,
      image: step15ballImage,
    },
    {
      label: 'questions.step15.list.5.label',
      description: 'questions.step15.list.5.description',
      value: PHYSICALLY_ACTIVE.EXTRA,
      image: step15trophyImage,
    },
  ],
  working_hours: [
    {
      label: 'questions.step16.list.1',
      value: WORKING_HOURS.FIVE_SIX,
      image: step16womanImage,
    },
    {
      label: 'questions.step16.list.2',
      value: WORKING_HOURS.NIGHT,
      image: step16policeImage,
    },
    {
      label: 'questions.step16.list.3',
      value: WORKING_HOURS.MIXED,
      image: step16technilogistImage,
    },
    {
      label: 'questions.step16.list.4',
      value: WORKING_HOURS.RETIRED,
      image: step16oldManImage,
    },
  ],
  stairs_breath: [
    {
      label: 'questions.step17.list.1',
      value: STAIRS_BREATH.CANNOT_TALK,
    },
    {
      label: 'questions.step17.list.2',
      value: STAIRS_BREATH.CAN_TALK,
    },
    {
      label: 'questions.step17.list.3',
      value: STAIRS_BREATH.OK,
    },
    {
      label: 'questions.step17.list.4',
      value: STAIRS_BREATH.EASILY,
    },
  ],
  walking_typical_day: [
    {
      label: 'questions.step18.list.1',
      value: WALKING_TYPICAL_DAY.LESS_TWENTY,
      image: step15yawningFaceImage,
    },
    {
      label: 'questions.step18.list.2',
      value: WALKING_TYPICAL_DAY.TWENTY_SIXTY,
      image: step18walkingManImage,
    },
    {
      label: 'questions.step18.list.3',
      value: WALKING_TYPICAL_DAY.MORE_SIXTY,
      image: step18runningManImage,
    },
  ],
  daily_meals: [
    {
      label: 'questions.step19.list.1',
      value: DAILY_MEALS.ONE_TWO,
    },
    {
      label: 'questions.step19.list.2',
      value: DAILY_MEALS.TWO_THREE,
    },
    {
      label: 'questions.step19.list.3',
      value: DAILY_MEALS.THREE_FOUR,
    },
    {
      label: 'questions.step19.list.4',
      value: DAILY_MEALS.MORE_FOUR,
    },
  ],
  bad_habits: [
    {
      label: 'questions.step21.list.1',
      value: BAD_HABITS.SNACK_TOO_OFTEN,
      image: step21popcornImage,
    },
    {
      label: 'questions.step21.list.2',
      value: BAD_HABITS.CRAVE_SALTY_FOODS,
      image: step21friesImage,
    },
    {
      label: 'questions.step21.list.3',
      value: BAD_HABITS.UNCONTROLLABLE_SWEET_TOOTH,
      image: step21lollipopImage,
    },
    {
      label: 'questions.step21.list.4',
      value: BAD_HABITS.DRINKING_SOFT_DRINKS,
      image: step21boxImage,
    },
    {
      label: 'questions.step21.list.5',
      value: BAD_HABITS.ALCOHOL_TOO_OFTEN,
      image: step21glassImage,
    },
    {
      label: 'questions.step21.list.6',
      value: BAD_HABITS.NONE,
      image: step6neverImage,
    },
  ],
  lifestyle: [
    {
      label: 'questions.step22.list.1',
      value: LIFESTYLE.SITTING,
    },
    {
      label: 'questions.step22.list.2',
      value: LIFESTYLE.MOVE,
    },
    {
      label: 'questions.step22.list.3',
      value: LIFESTYLE.FEET,
    },
  ],
  achieve_your_target_weight: [
    {
      label: 'questions.step23.list.1',
      value: ACHIEVE_YOUR_TARGET_WEIGHT.CANT_WAIT,
      image: step23partingFaceImage,
    },
    {
      label: 'questions.step23.list.2',
      value: ACHIEVE_YOUR_TARGET_WEIGHT.OPTIMISTIC,
      image: step23huggingFaceImage,
    },
    {
      label: 'questions.step23.list.3',
      value: ACHIEVE_YOUR_TARGET_WEIGHT.JUST_TRY,
      image: step23smilingFaceImage,
    },
  ],
  lose_weight_for: [
    {
      label: 'questions.step28.list.1',
      value: LOSE_WEIGHT_FOR.VACATION,
      image: step28airplaneImage,
    },
    {
      label: 'questions.step28.list.2',
      value: LOSE_WEIGHT_FOR.WEDDING,
      image: step28wineImage,
    },
    {
      label: 'questions.step28.list.3',
      value: LOSE_WEIGHT_FOR.EVENT,
      image: step28badmintonImage,
    },
    {
      label: 'questions.step28.list.4',
      value: LOSE_WEIGHT_FOR.BEACH,
      image: step28umbrellaImage,
    },
    {
      label: 'questions.step28.list.6',
      value: LOSE_WEIGHT_FOR.FAMILY,
      image: step28familyImage,
    },
    {
      label: 'questions.step28.list.7',
      value: LOSE_WEIGHT_FOR.OTHER,
      image: step28carImage,
    },
    {
      label: 'questions.step28.list.8',
      value: LOSE_WEIGHT_FOR.NONE,
      image: step6neverImage,
    },
  ],
};
